<template>
  <section>
    <div class="background-section-title">
      <div class="section-title">
        <h2>Grupos</h2>
      </div>
    </div>
      <div class="section-content">
        <div class="list-container">
          <div class="vld-parent">
            <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="fullPage"></loading>
          </div>
          <div class="header-container">
            <b-button class="new-group-button" @click="newGroup()">
              Cadastrar grupo
            </b-button>
            <div class="search-container">
              <b-input-group size="sm" class="mb-0">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="filterText" type="search" placeholder="Buscar..."></b-form-input>
              </b-input-group>
            </div>
          </div>
          <b-table :fields="fields" :items="filteredGroups" @filtered="onFiltered" :per-page="perPage" :current-page="currentPage">
            <template v-slot:cell(edit)="row">
              <img class="item-table" :src="editIcon" @click="editGroup(row.item, row.index, $event.target)">
            </template>
            <template v-slot:cell(active)="row">
            <b-form-checkbox switch size="lg" v-model="row.item.active" style="padding-top:13px" name="check-button" @change="enableGroup(row.item, row.index, $event)">
            </b-form-checkbox>
            </template>
            <template v-slot:cell(remove)="row">
              <img class="item-table" :src="deleteIcon" @click="deleteGroup(row.item, row.index, $event.target)">
            </template>
          </b-table>
          <div class="pagination-container">
            <b-row>
              <b-col class="my-3">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                ></b-pagination>
              </b-col>
              <b-col  class="my-3">
                <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                ></b-form-select>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-modal
            id="modal-prevent-closing"
            ref="modal"
            :ok-title="editing ? 'Editar' : 'Concluir'"
            cancel-title="Cancelar"
            cancel-variant="transparent"
            :title="modalTitle"
            @hidden="resetModal"
            modal-class="edit-title"
            @ok="handleModalOk"
            size="lg"
          >
            <b-form @submit.stop.prevent="handleSubmit">
            <b-row>
                <b-col>
                  <b-form-group label="Nome do grupo" label-for="name-input" :state="nameState" invalid-feedback="Nome é necessário">
                    <b-form-input :state="nameState" id="name-input" v-model="group.name" required placeholder="Digite o nome..." class="border border-dark"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Descrição do grupo" label-for="name-input">
                    <b-form-input id="group-description" v-model="group.description" placeholder="Digite a descrição..." class="border border-dark"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Permissões">
                    <b-form-checkbox-group
                            id="permissionGroup"
                            v-model="selectedPermissions"
                            :options="permissionsOptions"
                            stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-table :fields="usersField" :items="filteredUsersGroups" sticky-header class="user-table" style="{ max-height: 300px; height: 300px; }">
                    <template v-slot:cell(action)="row">
                      <b-form-checkbox size="md" v-model="row.item.action" name="check-button" @change="associateUser(row.item, row.index, $event)" :state="usersState">
                      </b-form-checkbox>
                    </template>
                  </b-table>
                </b-col>
            </b-row>
            </b-form>
        </b-modal>
      </div>
  </section>
</template>

<script>
  import { userService } from '../services/user_service';
  import { authorizationService } from '../services/authorization.service';
  import searchIcon from '@/assets/icons/magnify.svg';
  import deleteIcon from '@/assets/icons/delete.svg';
  import editIcon from '@/assets/icons/pencil.svg';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
      Loading
    },
    data () {
      return {
        searchIcon,
        deleteIcon,
        editIcon,
        sortDesc: false,
        sortBy: '',
        sortDirection: 'asc',
        filterOn: [],
        filter: null,
        perPage: 5,
        currentPage: 1,
        totalRows: 1,
        isBusy: false,
        filterText: '',
        filterUsersText: '',
        emptyText: 'Não há registros',
        pageOptions: [5, 10, 15, { value: 100, text: 'Mostrar 100' }],
        fields: [
          { key: 'name', label: 'Nome', sortable: false, sortDirection: 'desc' },
          { key: 'active', label: '', sortable: false, thStyle: { width: '50px' } },
          { key: 'edit', label: '', sortable: false, thStyle: { width: '50px' } },
          { key: 'remove', label: '', sortable: false, thStyle: { width: '100px' } }
        ],
        usersField: [
          { key: 'action', label: '', sortable: false, thStyle: { width: '50px' } },
          { key: 'name', label: 'Usuários vinculados', sortable: false, sortDirection: 'desc' }
        ],
        group: {
          id: '',
          name: '',
          users: [],
          description: '',
          enabled: true
        },
        submitted: false,
        editing: false,
        userInfo: undefined,
        selectedPermissions: [],
        permissionsOptions: [],
        selectedUser: [],
        userOptions: [],
        modalTitle: 'Novo grupo',
        nameState: null,
        usersState: null,
        isLoading: false,
        fullPage: true
      };
    },
    async mounted () {
      this.totalRows = 5;
      this.isLoading = true;
      this.userInfo = await userService.userInfo();
      if (this.userInfo === 'Timeout') {
        this.isLoading = false;
        this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
        return;
      }
      this.isLoading = false;
      if (this.userInfo && this.userInfo.organization && this.userInfo.organization.groups) {
        this.totalRows = this.userInfo.organization.groups.length;
      }
    },
    watch: {
      'group.name' () {
        this.nameState = this.group.name.length > 0;
      }
    },
    methods: {
      checkFormValidity () {
        this.nameState = this.group.name.length > 0;
        this.usersState = this.selectedUser.length > 0;
        return this.nameState && this.usersState;
      },
      async handleSubmit (e) {
        this.submitted = true;
        if (!this.checkFormValidity()) {
          return;
        }
        Object.assign(this.group, { accountId: this.userInfo.organization.id });
        Object.assign(this.group, { permissions: this.selectedPermissions, roles: [] });
        Object.assign(this.group, { users: this.selectedUser });
        if (this.editing) {
          await userService.groupUpdate(this.group);
          this.editing = false;
        } else {
          await userService.groupRegister(this.group);
        }
        this.isLoading = true;
        this.userInfo = await userService.userInfo();
        if (this.userInfo === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        this.isLoading = false;
        this.$toast.open('Grupo salvo com sucesso!');
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      },
      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      resetModal () {
        this.selectedUser = [];
        this.editing = false;
        this.group.name = '';
        this.group.description = '';
        this.group.users = [];
        this.group.enabled = true;
        this.nameState = null;
        this.usersState = null;
      },
      handleModalOk (bvModalEvt) {
        bvModalEvt.preventDefault();
        this.handleSubmit();
      },
      async newGroup () {
        if (this.$store.state.account.permissions && !this.$store.state.account.permissions.includes('CRIAR_GRUPO') && !this.$store.state.account.isAdmin) {
          this.$toast.open({ message: 'Usuário não possui permissão!', type: 'error' });
          return;
        }
        this.modalTitle = 'Editar grupo';
        this.permissionsOptions = [];
        this.selectedPermissions = [];
        const defaultPermissions = authorizationService.defaultPermissions();
        for (var key of Object.keys(defaultPermissions)) {
          this.permissionsOptions.push({ text: defaultPermissions[key], value: key });
        }
        if (this.userInfo && this.userInfo.organization) {
          this.userOptions = [];
          this.userInfo.organization.users.forEach(user => {
            if (user.trialId && user.active) {
              this.userOptions.push({ text: user.login, value: user.login });
            }
          });
        }

        this.$refs.modal.show();
      },
      async editGroup (item, index, button) {
        if (this.$store.state.account.permissions && !this.$store.state.account.permissions.includes('EDITAR_GRUPO') && !this.$store.state.account.isAdmin) {
          this.$toast.open({ message: 'Usuário não possui permissão!', type: 'error' });
          return;
        }
        this.group.id = item.id;
        this.group.name = item.name;
        this.group.description = item.description;
        this.group.enabled = item.enabled;
        this.permissionsOptions = [];
        this.selectedPermissions = [];
        const groupInfo = await userService.groupInfo(item.id);
        if (this.groupInfo === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        const defaultPermissions = authorizationService.defaultPermissions();
        for (var key of Object.keys(defaultPermissions)) {
          this.permissionsOptions.push({ text: defaultPermissions[key], value: key });
          groupInfo.permissions.filter(item => {
            if (item === key) {
              this.selectedPermissions.push(item);
            }
          });
        }
        if (this.userInfo && this.userInfo.organization) {
          this.userOptions = [];
          this.selectedUser = [];
          this.userInfo.organization.users.forEach(user => {
            if (user.trialId && user.active) {
              this.userOptions.push({ text: user.login, value: user.login });
            }
            groupInfo.users.filter(associatedUser => {
              if (associatedUser.login === user.login && user.active && user.trialId) {
                this.userOptions.find((item) => {
                  if (item.value === associatedUser.login) {
                    this.selectedUser.push({ login: associatedUser.login });
                    item.action = true;
                  }
                });
              }
            });
          });
        }
        this.modalTitle = 'Editar grupo';
        this.$refs.modal.show();
        this.editing = true;
      },
      async deleteGroup (item, index, button) {
        if (this.$store.state.account.permissions && !this.$store.state.account.permissions.includes('EXCLUIR_GRUPO') && !this.$store.state.account.isAdmin) {
          this.$toast.open({ message: 'Usuário não possui permissão!', type: 'error' });
          return;
        }
        this.$bvModal.msgBoxConfirm(`Tem certeza que deseja remover ${item.name} ?`, {
          title: 'Remover grupo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async value => {
            if (value) {
              await userService.groupRemove(item.id);
              this.userInfo = await userService.userInfo();
              if (this.userInfo === 'Timeout') {
                this.isLoading = false;
                this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
                return;
              }
              this.$toast.open('Grupo excluído com sucesso!');
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      async enableGroup (item, index, check) {
        item.enabled = check;
      },
      associateUser (item, index, check) {
        const user = this.selectedUser.find(value => value.login === item.name);
        if (!user) {
          this.selectedUser.push({ login: item.name });
        } else {
          const index = this.selectedUser.indexOf(user);
          if (index > -1) {
            this.selectedUser.splice(index, 1);
          }
        }
      }
    },
    computed: {
      filteredGroups: function () {
        const groups = [];
        if (this.userInfo && this.userInfo.organization && this.userInfo.organization.groups) {
          this.userInfo.organization.groups.filter(item => {
            groups.push({ name: item.name, id: item.id, active: item.active, description: item.description });
          });
        }
        return groups.filter(item => {
          if (this.filterText.length > 2) {
            return item.name.toLowerCase().includes(this.filterText.toLowerCase());
          } else {
            return item;
          }
        });
      },
      filteredUsersGroups: function () {
        const users = [];
        if (this.userInfo && this.userInfo.organization) {
          this.userOptions.filter(item => {
            users.push({ name: item.text, action: item.action });
          });
        }
        if (this.filterUsersText.length > 2 && users.length > 0) {
          return users.filter(item => {
            return item.name.toLowerCase().includes(this.filterUsersText.toLowerCase());
          });
        }
        return users;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .section-content {
    display: flex;

    .overlay {
        position: absolute;
        top: 5px;
        left: 10px;

        span {
          color: #ccc;
          font-size: 18px;
        }
    }

    .list-container {
      margin-left: 20px;
      margin-right: 20px;
      flex: 1;

      .header-container {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F5F8FA;
        border-radius: 4px;

        h3 {
          margin: 0;
          font-size: 20px;
          font-weight: 400;
        }

        .search-container {
          margin-right: 4%;
        }
      }

      .table {
        margin-top: 15px;
        background-color: #FFFFFF;
        border-radius: 4px;
        margin-bottom: 0px;
        /deep/thead th {
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 40px;
          letter-spacing: 0em;
          background: #F5F8FA;
          color: #6278A3;

          border-radius: 4px 4px 0px 0px;
          padding: 0.5rem;
          padding-left: 24px;
        }

        /deep/tbody td {
          font-size: 14px;
          padding: 0.5rem;
          font-size: 14px;
          font-style: normal;
          color: #6278A3;
          font-weight: 400;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          padding-left: 24px;
        }
      }

      .new-group-button {
        margin-left: 2%;
        background: #207BDD;
        border-radius: 4px;
        border-color: #207BDD;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: center;
        padding-left: 1.5%;
        padding-right: 1.5%;

          &:hover {
            background-color: #b5dcb1;
            transition: background-color 0.2s linear;
          }
      }

      .item-table {
        border-radius: 4px;
        background-color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  /deep/ .edit-title > .modal-dialog > .modal-content {
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: #6278A3;
    .user-table {
      thead th {
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
        color: #6278A3;
        border: none;

        border-radius: 4px 4px 0px 0px;
        padding: 0.5rem;
      }

      tbody td {
        padding: 0.5rem;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        color: #6278A3;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
  }

  .pagination-container {
    background-color: #FFFFFF;
    display: flex;
    flex-flow: row;
    align-content: center;
    alignment: center;
    padding-left: 35%;
  }

  /deep/.modal-header h5 {
    color: #007bff;
  }

  /deep/.modal-footer .btn-primary {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  /deep/.modal-footer .btn-transparent {
    background-color: #e5e5e5;
    color: #007bff;
    font-weight: 500;
  }
</style>
